// extracted by mini-css-extract-plugin
module.exports = {"fas":"Stars_fas__2jdhI","far":"Stars_far__1zUZE"};